import React from 'react';

import env from 'environment';
import styled from 'styled-components';

import useCollisionComponent from 'utils/useCollisionComponent';

const {
  PLATFORM_URL,
} = env;

const NavWrapper = () => {
  const options = {
    platformUrl: PLATFORM_URL,
    aydaUrl: '/',
    enableSearchBar: false,
  };

  const component = useCollisionComponent({
    name: 'nav_bar',
    css: ['front/navigation.css', 'front/dropit.css'],
    props: {
      options,
    },
  });

  return (
    <Wrapper>
      {component}
    </Wrapper>
  );
};

export default NavWrapper;

const Wrapper = styled.div`
  min-height: 80px;
`;



// WEBPACK FOOTER //
// ./app/components/Nav/index.js